export type SeasonKey =
	// | 'NO_CROP_SEASON'
	// | 'KHARIF_2020'
	// | 'RABI_2020'
	// | 'KHARIF_2021'
	// | 'RABI_2021'
	| 'KHARIF_2022'
	| 'RABI_2022'
	| 'RABI_2023'
	| 'KHARIF_2024'
	// | 'KHARIF_2023'
	| 'RABI_2024'
	| 'KHARIF_2025'
	| 'RABI_2025'
	| 'KHARIF_2026';
// | 'RABI_2026'
// | 'KHARIF_2027'
// | 'RABI_2027'
// | 'KHARIF_2028'
// | 'RABI_2028'
// | 'KHARIF_2029'
// | 'RABI_2029'
// | 'KHARIF_2030'
// | 'RABI_2030'
// | 'KHARIF_2031'
// | 'RABI_2031'
// | 'KHARIF_2032'
// | 'RABI_2033';

export const polygonFilterKharif2022 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'KHARIF_2022_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
		// {
		// 	combiningOperator: 'AND',
		// 	conditions: [
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_NAME',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagNames: ['GEOFENCE'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_KEY',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagProperties: ['KHARIF_2022_STATUS'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_VALUE',
		// 				operator: 'IN',
		// 				argument: {
		// 					values: [
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'GEOFENCING_SAVED',
		// 						},
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'GEOFENCING_PENDING',
		// 						},
		// 					],
		// 				},
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	combiningOperator: 'AND',
		// 	conditions: [
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_NAME',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagNames: ['GEOFENCE'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_KEY',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagProperties: ['GEOFENCE_SOURCE'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_VALUE',
		// 				operator: 'IN',
		// 				argument: {
		// 					values: [
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'MAPS PORTAL',
		// 						},
		// 					],
		// 				},
		// 			},
		// 		},
		// 	],
		// },
	],
};

export const pointFilterKharif2022 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'PROGRAM',
				TagPropertyKey: 'NAME',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['AWD_22_KHARIF_PROGRAM'],
				},
			},
		},
		// {
		// 	combiningOperator: 'AND',
		// 	conditions: [
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_NAME',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagNames: ['PROGRAM'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_KEY',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagProperties: ['NAME'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_VALUE',
		// 				operator: 'IN',
		// 				argument: {
		// 					values: [
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'AWD_22_KHARIF_PROGRAM',
		// 						},
		// 					],
		// 				},
		// 			},
		// 		},
		// 	],
		// },
	],
};

export const pointFilterRabi2023 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'PROGRAM',
				TagPropertyKey: 'NAME',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['AWD_23_RABI_PROGRAM'],
				},
			},
		},
		// {
		// 	combiningOperator: 'AND',
		// 	conditions: [
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_NAME',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagNames: ['PROGRAM'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_KEY',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagProperties: ['NAME'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_VALUE',
		// 				operator: 'IN',
		// 				argument: {
		// 					values: [
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'AWD_22_RABI_PROGRAM',
		// 						},
		// 					],
		// 				},
		// 			},
		// 		},
		// 	],
		// },
	],
};
export const pointFilterRabi2024 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'PROGRAM',
				TagPropertyKey: 'NAME',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['AWD_24_RABI_PROGRAM'],
				},
			},
		},
	],
};
export const polygonFilterRabi2024 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'RABI_2024_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
	],
};
export const polygonFilterRabi2023 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'RABI_2023_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
		// {
		// 	combiningOperator: 'AND',
		// 	conditions: [
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_NAME',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagNames: ['GEOFENCE'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_KEY',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagProperties: ['RABI_2022_STATUS'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_VALUE',
		// 				operator: 'IN',
		// 				argument: {
		// 					values: [
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'GEOFENCING_SAVED',
		// 						},
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'GEOFENCING_PENDING',
		// 						},
		// 					],
		// 				},
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	combiningOperator: 'AND',
		// 	conditions: [
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_NAME',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagNames: ['GEOFENCE'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_KEY',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagProperties: ['GEOFENCE_SOURCE'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_VALUE',
		// 				operator: 'IN',
		// 				argument: {
		// 					values: [
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'MAPS PORTAL',
		// 						},
		// 					],
		// 				},
		// 			},
		// 		},
		// 	],
		// },
	],
};
export const polygonFilterRabi2022 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'RABI_2022_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
		// {
		// 	combiningOperator: 'AND',
		// 	conditions: [
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_NAME',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagNames: ['GEOFENCE'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_KEY',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagProperties: ['RABI_2022_STATUS'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_VALUE',
		// 				operator: 'IN',
		// 				argument: {
		// 					values: [
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'GEOFENCING_SAVED',
		// 						},
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'GEOFENCING_PENDING',
		// 						},
		// 					],
		// 				},
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	combiningOperator: 'AND',
		// 	conditions: [
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_NAME',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagNames: ['GEOFENCE'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_KEY',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagProperties: ['GEOFENCE_SOURCE'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_VALUE',
		// 				operator: 'IN',
		// 				argument: {
		// 					values: [
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'MAPS PORTAL',
		// 						},
		// 					],
		// 				},
		// 			},
		// 		},
		// 	],
		// },
	],
};

export const pointFilterRabi2022 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'PROGRAM',
				TagPropertyKey: 'NAME',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['AWD_22_RABI_PROGRAM'],
				},
			},
		},
		// {
		// 	combiningOperator: 'AND',
		// 	conditions: [
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_NAME',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagNames: ['PROGRAM'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_KEY',
		// 				operator: 'IN',
		// 				argument: {
		// 					tagProperties: ['NAME'],
		// 				},
		// 			},
		// 		},
		// 		{
		// 			baseCondition: {
		// 				filterKey: 'TAG_VALUE',
		// 				operator: 'IN',
		// 				argument: {
		// 					values: [
		// 						{
		// 							valueType: 'VALUE_TYPE_STRING',
		// 							stringValue: 'AWD_22_RABI_PROGRAM',
		// 						},
		// 					],
		// 				},
		// 			},
		// 		},
		// 	],
		// },
	],
};

export const pointFilterKharif2024 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'PROGRAM',
				TagPropertyKey: 'NAME',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['AWD_24_KHARIF_PROGRAM'],
				},
			},
		},
	],
};

export const polygonFilterKharif2024 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'KHARIF_2024_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
	],
};

export const pointFilterKharif2025 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'PROGRAM',
				TagPropertyKey: 'NAME',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['AWD_25_KHARIF_PROGRAM'],
				},
			},
		},
	],
};
export const pointFilterRabi2025 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'PROGRAM',
				TagPropertyKey: 'NAME',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['AWD_25_RABI_PROGRAM'],
				},
			},
		},
	],
};
export const pointFilterKharif2026 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'PROGRAM',
				TagPropertyKey: 'NAME',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['AWD_26_KHARIF_PROGRAM'],
				},
			},
		},
	],
};

export const polygonFilterKharif2025 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'KHARIF_2025_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
	],
};
export const polygonFilterRabi2025 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'RABI_2025_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
	],
};
export const polygonFilterKharif2026 = {
	combiningOperator: 'AND',
	baseConditions: [
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'KHARIF_2026_STATUS',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['GEOFENCING_SAVED'],
				},
			},
		},
		{
			logicalOperator: 'IN',
			tag: {
				TagName: 'GEOFENCE',
				TagPropertyKey: 'GEOFENCE_SOURCE',
				value: {
					valueType: 'VALUE_TYPE_STRING',
					stringValues: ['MAPS PORTAL'],
				},
			},
		},
	],
};

export const AWD_SEASONS_CONFIG: Record<
	SeasonKey,
	{
		dataLayers: string[];
		label: string;
		suggestionLayers?: string[];
		filters: Record<string, any>;
		portalLockPropertyKey?: string;
		parentPointPropertyKey?: string;
		parentRefAttributeKey?: string;
		programNames: string[];
		geofenceFlowVersion: number;
		geofenceStatusPropertyKey:
			| 'KHARIF_2022_STATUS'
			| 'RABI_2022_STATUS'
			| 'RABI_2023_STATUS'
			| 'KHARIF_2024_STATUS'
			| 'RABI_2024_STATUS'
			| 'KHARIF_2025_STATUS'
			| 'RABI_2025_STATUS'
			| 'KHARIF_2026_STATUS';
		geofenceRejectionReasonsPropertyKey:
			| 'AWD_KHARIF_22_REJ_REASONS'
			| 'AWD_RABI_22_REJ_REASONS'
			| 'AWD_RABI_23_REJ_REASONS'
			| 'AWD_KHARIF_24_REJ_REASONS'
			| 'AWD_RABI_24_REJ_REASONS'
			| 'AWD_KHARIF_25_REJ_REASONS'
			| 'AWD_RABI_25_REJ_REASONS'
			| 'AWD_KHARIF_26_REJ_REASONS';
	}
> = {
	KHARIF_2022: {
		dataLayers: [
			'FARMS-USER_FARM-VILLAGE_FARM',
			'FARMS-INSIDE_BUND_SRC-DSR_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-CRM_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE',
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE',
		],
		label: 'Kharif 2022',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-VILLAGE_FARM': polygonFilterKharif2022,
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE':
				pointFilterKharif2022,
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE': pointFilterKharif2022,
		},
		parentPointPropertyKey: 'PLACE_ID',
		parentRefAttributeKey: 'KHARIF_22_CONTENT_ID_ATT',
		portalLockPropertyKey: 'KHARIF_22_PORTAL_EDIT',
		geofenceFlowVersion: 1,
		geofenceStatusPropertyKey: 'KHARIF_2022_STATUS',
		geofenceRejectionReasonsPropertyKey: 'AWD_KHARIF_22_REJ_REASONS',
		programNames: ['AWD_22_KHARIF_PROGRAM'],
	},
	RABI_2022: {
		dataLayers: [
			'FARMS-USER_FARM-VILLAGE_FARM',
			'FARMS-INSIDE_BUND_SRC-DSR_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-CRM_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE',
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE',
		],
		label: 'Rabi 2022',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-VILLAGE_FARM': polygonFilterRabi2022,
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE': pointFilterRabi2022,
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE': pointFilterRabi2022,
		},
		parentPointPropertyKey: 'AWD_RABI_22_NSV_PLACE_ID',
		parentRefAttributeKey: 'RABI_22_CONTENT_ID_ATT',
		portalLockPropertyKey: 'RABI_22_PORTAL_EDIT',
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'RABI_2022_STATUS',
		geofenceRejectionReasonsPropertyKey: 'AWD_RABI_22_REJ_REASONS',
		programNames: ['AWD_22_RABI_PROGRAM'],
	},
	RABI_2023: {
		dataLayers: [
			'FARMS-USER_FARM-VILLAGE_FARM',
			'FARMS-INSIDE_BUND_SRC-DSR_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-CRM_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE',
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE',
		],
		label: 'Rabi 2023',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-VILLAGE_FARM': polygonFilterRabi2023,
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE': pointFilterRabi2023,
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE': pointFilterRabi2023,
		},
		parentPointPropertyKey: 'AWD_RABI_23_NSV_PLACE_ID',
		parentRefAttributeKey: 'RABI_23_CONTENT_ID_ATT',
		portalLockPropertyKey: 'RABI_23_PORTAL_EDIT',
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'RABI_2023_STATUS',
		geofenceRejectionReasonsPropertyKey: 'AWD_RABI_23_REJ_REASONS',
		programNames: ['AWD_23_RABI_PROGRAM'],
	},
	KHARIF_2024: {
		dataLayers: [
			'FARMS-USER_FARM-VILLAGE_FARM',
			'FARMS-INSIDE_BUND_SRC-DSR_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-CRM_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE',
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE',
		],
		label: 'Kharif 2024',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-VILLAGE_FARM': polygonFilterKharif2024,
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE':
				pointFilterKharif2024,
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE': pointFilterKharif2024,
		},
		parentPointPropertyKey: 'AWD_KHARIF_24_NSV_PLACE_ID',
		parentRefAttributeKey: 'KHARIF_24_CONTENT_ID_ATT',
		portalLockPropertyKey: 'KHARIF_24_PORTAL_EDIT',
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'KHARIF_2024_STATUS',
		geofenceRejectionReasonsPropertyKey: 'AWD_KHARIF_24_REJ_REASONS',
		programNames: ['AWD_24_KHARIF_PROGRAM'],
	},
	RABI_2024: {
		dataLayers: [
			'FARMS-USER_FARM-VILLAGE_FARM',
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE',
		],
		label: 'Rabi 2024',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-VILLAGE_FARM': polygonFilterRabi2024,
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE': pointFilterRabi2024,
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE': pointFilterRabi2024,
		},
		parentPointPropertyKey: 'AWD_RABI_24_NSV_PLACE_ID',
		parentRefAttributeKey: 'RABI_24_CONTENT_ID_ATT',
		portalLockPropertyKey: 'RABI_24_PORTAL_EDIT',
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'RABI_2024_STATUS',
		geofenceRejectionReasonsPropertyKey: 'AWD_RABI_24_REJ_REASONS',
		programNames: ['AWD_24_RABI_PROGRAM'],
	},
	KHARIF_2025: {
		dataLayers: [
			'FARMS-USER_FARM-VILLAGE_FARM',
			'FARMS-INSIDE_BUND_SRC-DSR_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-CRM_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE',
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE',
		],
		label: 'Kharif 2025',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-VILLAGE_FARM': polygonFilterKharif2025,
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE':
				pointFilterKharif2025,
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE': pointFilterKharif2025,
		},
		parentPointPropertyKey: 'AWD_KHARIF_25_NSV_PLACE_ID',
		parentRefAttributeKey: 'KHARIF_25_CONTENT_ID_ATT',
		portalLockPropertyKey: 'KHARIF_25_PORTAL_EDIT',
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'KHARIF_2025_STATUS',
		geofenceRejectionReasonsPropertyKey: 'AWD_KHARIF_25_REJ_REASONS',
		programNames: ['AWD_25_KHARIF_PROGRAM'],
	},
	RABI_2025: {
		dataLayers: [
			'FARMS-USER_FARM-VILLAGE_FARM',
			'FARMS-INSIDE_BUND_SRC-DSR_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-CRM_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE',
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE',
		],
		label: 'Rabi 2025',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-VILLAGE_FARM': polygonFilterRabi2025,
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE': pointFilterRabi2025,
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE': pointFilterRabi2025,
		},
		parentPointPropertyKey: 'AWD_RABI_25_NSV_PLACE_ID',
		parentRefAttributeKey: 'RABI_25_CONTENT_ID_ATT',
		portalLockPropertyKey: 'RABI_25_PORTAL_EDIT',
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'RABI_2025_STATUS',
		geofenceRejectionReasonsPropertyKey: 'AWD_RABI_25_REJ_REASONS',
		programNames: ['AWD_25_RABI_PROGRAM'],
	},
	KHARIF_2026: {
		dataLayers: [
			'FARMS-USER_FARM-VILLAGE_FARM',
			'FARMS-INSIDE_BUND_SRC-DSR_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-CRM_PROGRAM_TYPE',
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE',
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE',
		],
		label: 'Kharif 2026',
		suggestionLayers: ['FARMS-SATELLITE_FARM-VILLAGE_FARM'],
		filters: {
			'FARMS-USER_FARM-VILLAGE_FARM': polygonFilterKharif2026,
			'FARMS-PIPE_INSTALLATION_SRC-AWD_PROGRAM_TYPE':
				pointFilterKharif2026,
			'FARMS-INSIDE_BUND_SRC-AWD_PROGRAM_TYPE': pointFilterKharif2026,
		},
		parentPointPropertyKey: 'AWD_KHARIF_26_NSV_PLACE_ID',
		parentRefAttributeKey: 'KHARIF_26_CONTENT_ID_ATT',
		portalLockPropertyKey: 'KHARIF_26_PORTAL_EDIT',
		geofenceFlowVersion: 2,
		geofenceStatusPropertyKey: 'KHARIF_2026_STATUS',
		geofenceRejectionReasonsPropertyKey: 'AWD_KHARIF_26_REJ_REASONS',
		programNames: ['AWD_26_KHARIF_PROGRAM'],
	},
};
